import React from 'react';
import {
  UnitsTileConfig,
  UnitsTileProps,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/types';

export interface IMarketplaceContext {
  state: UnitsTileConfig,
  updateState: React.Dispatch<React.SetStateAction<UnitsTileConfig>>,
}

export const UnitsDataContext = React.createContext<IMarketplaceContext | null>(null);

export const UnitsDataProvider = ({ children, data }: UnitsTileProps) => {
  const [state, updateState] = React.useState(data);
  const value = { state, updateState };
  return (
    <UnitsDataContext.Provider value={value}>
      { children }
    </UnitsDataContext.Provider>
  );
};

// export const UnitsDataConsumer = ({ children }: { children: (context: IMarketplaceContext) => React.ReactNode }) => {
//   return (
//     <UnitsDataContext.Consumer>
//       {(context) => {
//         if (context === undefined || context === null) {
//           throw new Error('UnitsDataContext must be used within a UnitsDataProvider');
//         }
//         return children && children(context);
//       }}
//     </UnitsDataContext.Consumer>
//   );
// };
